"use client";

import React from "react";

interface DetailsPanelFooterProps {
  children: React.ReactNode;
}

export const DetailsPanelFooter: React.FC<DetailsPanelFooterProps> = ({ children }) => {
  return (
    <div className="flex shrink-0 flex-col gap-2 rounded-b-xl border-t border-gray-200 bg-white p-3">
      {children}
    </div>
  );
};
